import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classnames from 'classnames';
import IconLabel from '../util/IconLabel';
import CapacitorRipple from '../capacitor/Ripple';
import styles from './ShareButton.css';
import { injectIntl, intlShape } from 'react-intl';
import { commonMessages } from '../messages/Common';

class RemoveFromPlaylistButton extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    hideText: PropTypes.bool,
    disabled: PropTypes.bool,
    intl: intlShape,
  };

  static defaultProps = {
    hideText: true,
  };

  onClick = () => {
    if (this.props.disabled) {
      return;
    }

    this.props.onClick();
  };

  render() {
    const { className, hideText, intl, disabled } = this.props;

    const buttonClassNames = classnames(styles.shareButton, className, {
      [styles.isDisabled]: disabled,
    });

    const title = intl.formatMessage(commonMessages.removeFromPlaylist);

    return (
      <button
        className={buttonClassNames}
        onClick={this.onClick}
        title={title}
        aria-label={hideText ? title : null}
        data-test="remove-from-playlist-btn"
        disabled={disabled}
      >
        <CapacitorRipple />
        <IconLabel
          name="delete"
          size={hideText ? 'default' : 'small'}
          labelVisible={!hideText}
          label={title}
        />
      </button>
    );
  }
}

export default injectIntl(RemoveFromPlaylistButton);
